import { render, staticRenderFns } from "./EventItemSearch.vue?vue&type=template&id=81010f8e&"
import script from "./EventItemSearch.vue?vue&type=script&lang=js&"
export * from "./EventItemSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports